import script from "./labExpertOpinion.vue?vue&type=script&setup=true&lang=js"
export * from "./labExpertOpinion.vue?vue&type=script&setup=true&lang=js"

import "./labExpertOpinion.vue?vue&type=style&index=0&id=1f32d79a&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f32d79a"]])

export default __exports__